﻿import TKFormElement from '@/controls/kdmz.form.element';
import { NotificationType, sendNotification, sendNotificationByItem } from '@tk/utilities/tk.notification';

export default class KDMZFormElement extends TKFormElement {
    select?: HTMLSelectElement;
    checkbox?: HTMLInputElement;
    range?: HTMLInputElement;
    number?: HTMLInputElement;
    noEnterInput?: HTMLInputElement;
    evt: Event;

    constructor() {
        super();

        this.select = this.querySelector('select') as HTMLSelectElement;
        this.checkbox = this.querySelector('input[type="checkbox"]') as HTMLInputElement;
        this.range = this.querySelector('input[type="range"]') as HTMLInputElement;
        this.number = this.querySelector('input[type="number"]') as HTMLInputElement;
        this.noEnterInput =
            this.querySelector('input[type="email"]') ||
            this.querySelector('input[type="text"]') ||
            (this.querySelector('input[type="number"]') as HTMLInputElement);
        this.evt = new Event('change');
    }

    connectedCallback() {
        super.connectedCallback();
        const onSelectChange = this.handleSelectChange.bind(this);
        const onCheckboxChange = this.handleCheckboxChange.bind(this);
        const onRangeChange = this.handleRangeChange.bind(this);
        const onNumberInputChange = this.handleNamberInputChange.bind(this);

        if (this.select) {
            this.pushListener({ event: 'change', element: this.select, action: onSelectChange });
            this.handleSelectChange();
        }

        if (this.checkbox) {
            this.pushListener({ event: 'change', element: this.checkbox, action: onCheckboxChange });
            // this.handleCheckboxChange();
        }

        if (this.range) {
            this.pushListener({ event: 'change', element: this.range, action: onRangeChange });
        }

        if (this.number) {
            this.pushListener({ event: 'change', element: this.number, action: onNumberInputChange });
        }

        if (this.noEnterInput) {
            this.pushListener({ event: 'keydown', element: this.noEnterInput, action: this.handleKeydown.bind(this) });
        }
    }

    /**
     * Handles changes to the select element.
     * Toggles the 'tk-form-select--filled' class based on the select element's value.
     */
    handleSelectChange(): void {
        if (!this.select) return;
        this.classList.toggle('tk-form-select--filled', this.select.value !== '');
    }

    /**
     * Handles changes to the checkbox element.
     */
    handleCheckboxChange(): void {
        if (!this.checkbox) return;
        // Checkboxen
        if (this.hasAttribute('data-form-switch-url')) {
            location.href = this.dataset.formSwitchUrl;
        }
        if (this.checkbox.hasAttribute('data-checkbox-toggle-master')) {
            this.toggleAllCheckboxes(this.checkbox, this.checkbox.checked);
        }
        if (this.checkbox.hasAttribute('data-checkbox-toggle')) {
            this.toggleMasterCheckbox(this.checkbox);
        }
    }

    /**
     * Handles changes to the range element.
     */
    handleRangeChange(): void {
        if (!this.range) return;
        // Range Toggler
        if (this.range.hasAttribute('data-range-toggle-master')) {
            this.toggleAllRanges(this.range, this.range.value);
        }
        if (this.range.hasAttribute('data-range-toggle')) {
            // this.toggleMasterRange(this.range);
            // const masterRange: HTMLInputElement = document.querySelector('input[data-range-toggle-master]')!;
            // if (this.closest('#approval-form') && this.range.value !== masterRange.value) {
            //     masterRange.value = '1';
            //     masterRange.setAttribute('value', '1');
            //     masterRange.parentElement!.querySelector('label')!.innerText = '';
            // }
        }
    }

    // Checkboxes
    toggleAllCheckboxes(toggler: HTMLInputElement, status: boolean): void {
        const allCheckboxes: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[data-checkbox-toggle]');
        Array.from(allCheckboxes).forEach((box) => {
            if (box.checked !== status && !box.disabled) {
                box.checked = status;
                // box.dispatchEvent(this.evt);
            }
        });
    }

    toggleMasterCheckbox(box: HTMLInputElement): void {
        const masterCheckbox: HTMLInputElement = document.querySelector('input[data-checkbox-toggle-master]')!;
        const isChecked: boolean = box.checked;
        if (!isChecked) {
            masterCheckbox.checked = false;
        }
    }

    // Range Toggler
    toggleAllRanges(toggler: HTMLInputElement, val: string): void {
        const allRanges: NodeListOf<HTMLInputElement> = document.querySelectorAll('input[data-range-toggle]');
        Array.from(allRanges).forEach((range) => {
            if (range.value !== val && !range.disabled) {
                range.value = val;
                range.click();
                // range.dispatchEvent(this.evt);
            }
        });

        if (toggler.closest('#approval-form') && val === '1') {
            const appForm = toggler.closest('#approval-form');
            appForm!.querySelector('.tk-tabs-accordion')!.classList.add('tk-tabs-accordion--active');
            appForm!.querySelector('.tk-tabs-accordion [data-tk-accordion-icon]')!.classList.remove('tk-icon-add');
            appForm!.querySelector('.tk-tabs-accordion [data-tk-accordion-icon]')!.classList.add('tk-icon-remove');
        } else {
            const appForm = toggler.closest('#approval-form');
            appForm!.querySelector('.tk-tabs-accordion')!.classList.remove('tk-tabs-accordion--active');
            appForm!.querySelector('.tk-tabs-accordion [data-tk-accordion-icon]')!.classList.remove('tk-icon-remove');
            appForm!.querySelector('.tk-tabs-accordion [data-tk-accordion-icon]')!.classList.add('tk-icon-add');
        }

        if (toggler.closest('.approval-form-header')) {
            const appFormHeader = toggler.closest('.approval-form-header');
            if (val === '0') {
                appFormHeader!.querySelector('.tk-form-textarea')!.classList.remove('hidden');
                appFormHeader!.querySelector('.tk-form-textarea textarea')!.setAttribute('required', 'required');
                appFormHeader!.querySelector('kdmz-action')!.removeAttribute('hidden');
            } else {
                if (val === '2') {
                    appFormHeader!.querySelector('kdmz-action')!.removeAttribute('hidden');
                } else {
                    appFormHeader!.querySelector('kdmz-action')!.setAttribute('hidden', '');
                }
                appFormHeader!.querySelector('.tk-form-textarea')!.classList.add('hidden');
                appFormHeader!.querySelector('.tk-form-textarea textarea')!.removeAttribute('required');
            }
        }
    }

    toggleMasterRange(range: HTMLInputElement): void {
        const masterRange: HTMLInputElement = document.querySelector('input[data-range-toggle-master]')!;
        const val: number = Number(range.value);
        if (val) {
            masterRange.value = String(val);
        }
    }

    // #region Required
    checkRequiredAttribute() {
        if (
            !this.labelElement ||
            !this.fieldElement ||
            !this.fieldElement.hasAttribute('required') ||
            this.fieldElement.closest('.o-toggle-info') ||
            this.labelElement.textContent.includes('*') ||
            (this.fieldElement.hasAttribute('data-required-has-flag') &&
                this.fieldElement.dataset.requiredHasFlag == 'false')
        )
            return;
        this.labelElement.textContent = `${this.labelElement.textContent} *`;
    }

    handleNamberInputChange(): void {
        if (!this.number) return;

        this.number.value = this.number.value.replace(/"/g, () => {
            let i = 0;
            return i++ % 2 === 0 ? '“' : '”';
        });

        const value = parseFloat(this.number.value.replace(/,/g, '.'));
        const stepAttr = this.number.getAttribute('step');
        const minAttr = this.number.getAttribute('min');
        const maxAttr = this.number.getAttribute('max');

        const step = stepAttr ? parseFloat(stepAttr) : 1;
        const min = minAttr ? parseFloat(minAttr) : step;
        const max = maxAttr ? parseFloat(maxAttr) : 0;

        if (!isNaN(value)) {
            const rounded = this.roundToStep(value, step, min, max);
            if (rounded > min) {
                this.number.value = rounded.toString();
            } else {
                this.number.value = min.toString();
            }

            if (max > 0 && rounded > max) {
                this.number.value = max.toString();
            }
        }
    }

    // Hilfsfunktion zum Runden auf das nächste Vielfache von "step" ab "min"
    roundToStep(value: number, step: number, min: number, max: number): number {
        // return Math.round((value - min) / step) * step + min;
        const returnVal = Math.ceil((value - min) / step) * step + min;
        if (returnVal > max && max > 0) {
            sendNotification(NotificationType.WARNING, 'Maximalmenge erreicht');
        }
        return returnVal > max && max > 0 ? max : returnVal;
    }

    handleKeydown(event: KeyboardEvent) {
        const form = this.closest('form');
        if (event.key === 'Enter' && form?.hasAttribute('do-not-send-on-enter')) {
            event.preventDefault();
            this.noEnterInput?.blur();
        }
    }
}
